import React from "react";
import { Card, CardBody, CardHeader, Col, Row, Table } from "reactstrap";
import { usePettyWorkOverview } from "./PettyWorkOverviewContext";
import { pettyWorkLineQuantity } from "features/PettyWorks/utils/petty-work.utils";
import {
  WorkOrderItemTypeLabelMap,
  type WorkOrderItemTypeValue,
} from "features/WorkOrders/constants/work-order-item.constants";
import { formatCurrency } from "utils/currency";

const LineItemsTab = () => {
  const { pettyWork } = usePettyWorkOverview();

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <h5 className="card-title mb-0">Line items (BOQ)</h5>
            </CardHeader>
            <CardBody>
              {pettyWork?.items?.length ? (
                <div className="table-responsive table-card">
                  <Table className="table-bordered table-nowrap mb-0 align-middle">
                    <thead className="table-light text-muted small">
                      <tr>
                        <th>#</th>
                        <th>Type</th>
                        <th>Product / description</th>
                        <th>Unit</th>
                        <th className="text-end">Rate</th>
                        <th className="text-end">Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pettyWork.items.map((ln, i) => (
                        <tr key={ln.id ?? i}>
                          <td>{i + 1}</td>
                          <td>
                            {ln.type
                              ? (WorkOrderItemTypeLabelMap[
                                  ln.type as WorkOrderItemTypeValue
                                ] ?? ln.type)
                              : "—"}
                          </td>
                          <td style={{ whiteSpace: "pre-wrap" }}>
                            {ln.product?.name?.trim()
                              ? ln.product.name
                              : (ln.description?.trim() ?? "—")}
                          </td>
                          <td>{ln.unit ?? "—"}</td>
                          <td className="text-end tabular-nums">
                            {formatCurrency(ln.rate ?? 0)}
                          </td>
                          <td className="text-end tabular-nums">
                            {pettyWorkLineQuantity(ln)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <p className="text-muted mb-0">No line items.</p>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default LineItemsTab;
